import React from 'react';
import styled from 'astroturf/react';

import { ImpressionWatcher } from 'js/utils/impressions/ImpressionWatcher';
import { Body } from 'js/design_system/Body';
import { Icon } from 'js/design_system/Icon';
import { ImpressionPropsGenerator } from 'js/social/ImpressionHelper';
import { useCurrentUserAsFollowableUser } from '../CreateSocialItem/useCurrentUserAsFollowableUser';
import { AuthorHeader } from '../News/AuthorHeader';

const Wrapper = styled.div<{ background: 'white' | 'gray' }>`
  border-radius: 8px;
  padding: 24px;
  border: 1px solid var(--stroke-medium, #535366);
  display: flex;
  flex-direction: column;
  gap: 12px;

  &.background-white {
    background: white;
  }

  &.background-gray {
    background: var(--brand-colors-neutral-200, #f8f8fb);
  }
`;

const StartCommentPromptWrapper = styled(ImpressionWatcher)`
  display: flex;
  flex-direction: column;
`;

const StartCommentPrompt = styled.button`
  appearance: none;
  cursor: pointer;
  display: flex;
  padding: 12px 16px;
  border-radius: 4px;
  border: 1px solid var(--stroke-medium, #535366);
  background: white;
  color: var(--text-placeholder, #6d6d7d);
  min-height: 80px;
`;

const PublicNotice = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  color: var(--text-secondary, #535366);
`;

const PublicText = styled(Body)`
  line-height: 20px;
`;

interface SidebarAddCommentProps {
  background?: 'white' | 'gray';
  onStartComment(): void;
  impressionPropsGen: ImpressionPropsGenerator;
}

const SidebarAddComment = ({
  background = 'white',
  onStartComment,
  impressionPropsGen,
}: SidebarAddCommentProps) => {
  const author = useCurrentUserAsFollowableUser();

  if (!author) {
    return null;
  }

  return (
    <Wrapper background={background}>
      <Body size="md" bold>
        Add your comments
      </Body>
      <AuthorHeader
        kind="user"
        user={author}
        size="sm"
        showAvatar={true}
        showTimestamp={false}
        impressionPropsGen={impressionPropsGen}
      />
      <StartCommentPromptWrapper
        {...impressionPropsGen()()('sidebar-add-comment')}
      >
        <StartCommentPrompt onClick={onStartComment}>
          <Body size="md">Add your comments...</Body>
        </StartCommentPrompt>
      </StartCommentPromptWrapper>
      <PublicNotice>
        <Icon name="public" />
        <PublicText size="sm">Public to all researchers</PublicText>
      </PublicNotice>
    </Wrapper>
  );
};

export default SidebarAddComment;
